'use strict';

var baseLogin = require('base/login/login');
var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var registrationFormManager = require('../register/register');
var googleRecaptcha = require('int_google/googleRecaptcha');

/**
 * Handle form submission AJAX call
 * @param {jQuery} form - Form jQuery object
 * @param {string} url - Form action URL
 * @param {Event} e - Submit event
 */
function submitRegistrationForm(form, url, e) {
    form.spinner().start();
    (googleRecaptcha.getRecaptchaToken()).then((recaptchaTokenData) => {
        if (recaptchaTokenData && recaptchaTokenData.success) {
            let formData = form.serialize();
            formData = formData + '&recaptchaToken=' + recaptchaTokenData.recaptchaToken;
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success: function (data) {
                    form.spinner().stop();
                    if (data.recaptchaError) {
                        if (data.recaptchErrorMsg) {
                            createErrorNotification($('.error-messaging'), data.recaptchErrorMsg);
                        }
                        $('form.registration').trigger('login:register:error', data);
                        return;
                    }
                    if (!data.success) {
                        $('form.registration').trigger('login:register:error', data);
                        if (data.form && data.form.error && !data.error) {
                            data.error = [data.form.error];
                        }

                        // If club member is checked and there's a form error, navigate to step 1
                        if (registrationFormManager && registrationFormManager.isClubMemberChecked()) {
                            registrationFormManager.goToStep1();
                        }

                        formValidation(form, data);
                        // Show invalid-feedback elements that have content (formValidation sets HTML but doesn't show them)
                        form.find('.invalid-feedback').each(function () {
                            if ($(this).html() && $(this).html().trim() !== '') {
                                $(this).show();
                            }
                        });
                    } else {
                        $('form.registration').trigger('login:register:success', data);
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (err) {
                    form.spinner().stop();
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else if (err.responseJSON && err.responseJSON.errorMessage) {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }
                    $('form.registration').trigger('login:register:error', err);
                }
            });
        } else {
            form.spinner().stop();
        }
    }).catch(function (error) {
        form.spinner().stop();
        $('form.registration').trigger('login:register:error', error);
        if (error && error.errorMsg) {
            createErrorNotification($('.error-messaging'), error.errorMsg);
        }
    });
}

module.exports = {
    login: function () {
        // Use base login submit handler (no custom validation)
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            (googleRecaptcha.getRecaptchaToken()).then((recaptchaTokenData) => {
                if (recaptchaTokenData && recaptchaTokenData.success) {
                    let formData = form.serialize();
                    formData = formData + '&recaptchaToken=' + recaptchaTokenData.recaptchaToken;
                    $('form.login').trigger('login:submit', e);
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        data: formData,
                        success: function (data) {
                            form.spinner().stop();
                            if (data.recaptchaError) {
                                if (data.recaptchErrorMsg) {
                                    createErrorNotification($('.error-messaging'), data.recaptchErrorMsg);
                                }
                                $('form.login').trigger('login:error', data);
                                return;
                            }
                            if (!data.success) {
                                formValidation(form, data);
                                $('form.login').trigger('login:error', data);
                            } else {
                                $('form.login').trigger('login:success', data);
                                window.location.href = data.redirectUrl;
                            }
                        },
                        error: function (data) {
                            if (data.responseJSON.redirectUrl) {
                                window.location.href = data.responseJSON.redirectUrl;
                            } else {
                                $('form.login').trigger('login:error', data);
                                form.spinner().stop();
                            }
                        }
                    });
                } else {
                    form.spinner().stop();
                }
            }).catch(function (error) {
                form.spinner().stop();
                $('form.login').trigger('login:error', error);
                if (error && error.errorMsg) {
                    createErrorNotification($('.error-messaging'), error.errorMsg);
                }
            });
            return false;
        });
    },

    register: function () {
        // Override form submit handler
        $('form.registration').on('submit', function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr('action');

            // Ensure registrationFormManager is available
            if (!registrationFormManager) {
                // Fallback to base behavior if manager not available
                submitRegistrationForm(form, url, e);
                return false;
            }

            var isClubMemberChecked = registrationFormManager.isClubMemberChecked();

            // If clubMember is NOT checked, do normal OOTB registration
            if (!isClubMemberChecked) {
                submitRegistrationForm(form, url, e);
                return false;
            }

            // If clubMember IS checked, handle multi-step logic
            var currentStep = registrationFormManager.getCurrentStep();
            if (currentStep !== 'step3') {
                // Prevent submission if not on step 3
                return false;
            }

            if (!registrationFormManager.validateCurrentStep()) {
                return false;
            }

            // Disabled fields are automatically excluded from form.serialize() and won't block HTML5 validation
            submitRegistrationForm(form, url, e);
            return false;
        });
    },

    handleResetPassword: function () {
        $('form.change-password-form').on('submit', function (e) {
            e.preventDefault();
            var $form = $(this);
            var $msg = $('.reset-password-message');
            $form.find('button[type="submit"]').prop('disabled', true);

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                data: $form.serialize(),
                success: function (response) {
                    if (response.success) {
                        var seconds = 5;
                        $form.addClass('d-none');
                        $msg
                            .removeClass('d-none color-danger')
                            .html(
                                response.message + ' <span class="redirect-timer">5</span> seconds…'
                            );

                        var timer = setInterval(function () {
                            seconds -= 1;
                            $('.redirect-timer').text(seconds);

                            if (seconds <= 0) {
                                clearInterval(timer);
                                window.location.href = response.redirectUrl;
                            }
                        }, 1000);
                    } else {
                        $msg
                            .removeClass('d-none')
                            .addClass('color-danger')
                            .text(response.message);
                        $form.find('button[type="submit"]').prop('disabled', false);
                    }
                },
                error: function () {
                    $msg
                        .removeClass('d-none')
                        .addClass('color-danger')
                        .text($msg.data('message-error'));
                    $form.find('button[type="submit"]').prop('disabled', false);
                }
            });
        });
    },

    resetPassword: baseLogin.resetPassword,

    clearResetForm: baseLogin.clearResetForm
};

